import { icons } from '../../icons';
import cn from '../../utils/cn';

export default function KoobSidebarUser({
  user,
  collapsed = false,
  impersonating = false,
  onLogout,
  onStopImpersonating,
}) {
  if (!user) return null;

  const initials = (user.name || '')
    .split(' ')
    .filter(Boolean)
    .map((n) => n[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

  const handleAction = impersonating ? onStopImpersonating : onLogout;
  const actionIcon = impersonating ? icons.impersonationStop : icons.logout;

  return (
    <div
      className={cn(
        'flex items-center gap-3 px-4 py-3',
        collapsed && 'flex-col justify-center px-2 gap-2',
      )}
    >
      {/* Avatar */}
      <div className="relative shrink-0">
        <div
          className="flex items-center justify-center w-8 h-8 rounded-full text-white text-xs font-semibold"
          style={{ background: 'linear-gradient(to bottom, #F68B11, #F67008)' }}
        >
          {initials || <i className={cn(icons.traveler, 'fa-fw text-xs')} />}
        </div>
        {impersonating && (
          <div className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full border-2 border-white" />
        )}
      </div>

      {/* Name + org + impersonating badge */}
      {!collapsed && (
        <div className="min-w-0 flex-1">
          <div className="text-sm font-medium text-gray-900 truncate">
            {user.name}
          </div>
          {user.organization && (
            <div className="text-xs text-gray-500 truncate">
              {user.organization}
            </div>
          )}
          {impersonating && (
            <span className="inline-block mt-0.5 text-[10px] font-semibold text-red-600 bg-red-50 rounded px-1.5 py-0.5 leading-none">
              Impersonating
            </span>
          )}
        </div>
      )}

      {/* Logout / Stop impersonating button */}
      {handleAction && (
        <button
          onClick={handleAction}
          className={cn(
            'border-none bg-transparent rounded-md transition cursor-pointer shrink-0 p-1.5',
            impersonating
              ? 'text-red-500 hover:bg-red-50 hover:text-red-600'
              : 'text-gray-400 hover:bg-gray-100 hover:text-gray-600',
          )}
          title={impersonating ? 'Stop impersonating' : 'Sign out'}
        >
          <i className={cn(actionIcon, 'fa-fw text-sm')} />
        </button>
      )}
    </div>
  );
}
